<template>
  <v-window>
    <v-content
      :class="{
        landscape: isLandscape(),
        portrait: !isLandscape(),
        large: isLarge(),
        xs: $vuetify.breakpoint.xs,
        sm: $vuetify.breakpoint.sm,
        md: $vuetify.breakpoint.md,
        lg: $vuetify.breakpoint.lg,
        xl: $vuetify.breakpoint.xl
      }"
    >
      <!-- Header -->
      <v-toolbar
        class="primary"
        app
        dark
        dense
        flat
        :height="toolbarHeight"
        style="z-index: 10"
      >
        <!-- Mobile Header -->
        <div class="hidden-md-and-up" style="width: 100%">
          <v-layout row align-center>
            <v-flex xs8>
              <router-link to="/">
                <v-img
                  src="/image/logo_bg_white.png"
                  width="150px"
                  height="30px"
                  class="ml-2"
                >
                </v-img>
              </router-link>
            </v-flex>
            <v-flex xs4 class="text-xs-right">
              <v-btn flat small color="white" class="ma-0" @click="logout">
                <v-icon left small>exit_to_app</v-icon>
                Cerrar Sesión
              </v-btn>
            </v-flex>
          </v-layout>
        </div>

        <!-- Desktop Header -->
        <div class="hidden-sm-and-down" style="width: 100%">
          <v-layout row align-center>
            <v-flex xs6>
              <router-link to="/">
                <v-img
                  src="/image/logo_bg_white.png"
                  width="200px"
                  height="40px"
                  class="ml-3"
                >
                </v-img>
              </router-link>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <v-btn flat color="white" class="ma-0 mr-3" @click="logout">
                <v-icon left>exit_to_app</v-icon>
                Cerrar Sesión
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-toolbar>

      <section class="legal-hero">
        <v-container>
          <v-layout align-center justify-center>
            <v-flex xs12 md8 text-xs-center>
              <h1 class="display-2 white--text font-weight-light mb-3">
                Comunicado Oficial
              </h1>
              <p class="headline white--text mb-4">
                Cierre temporal de wesmartPark en Chile
              </p>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <!-- Legal Content -->
      <v-container fluid class="pa-0">
        <v-layout row wrap justify-center>
          <v-flex xs12 sm10 md8 lg6>
            <v-card flat class="pa-5">
              <v-card-text>
                <p class="body-1 mb-4">
                  Por motivos contractuales con nuestros antiguos socios
                  locales, wesmartPark dejará de operar en Santiago de Chile a
                  partir del <b>31 de julio</b>.
                </p>

                <p class="body-1 mb-4">
                  Tuvimos diferencias importantes con nuestros antiguos socios,
                  y se ha decidido poner el caso en manos de la justicia.
                </p>

                <p class="body-1 mb-4">
                  Pero no es un adiós... ¡Estamos trabajando para volver pronto
                  y mejor!
                </p>

                <p class="body-1 mb-4 typeform-container"></p>

                <p class="body-1 mb-4">
                  Gracias por haber sido parte de esta historia.
                </p>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-window>
</template>

<script>
import authService from '@/services/authService';
import store from '@/store';

export default {
  name: 'LegalAdvice',
  components: {},
  data() {
    return {
      toolbarHeight: 56,
      legalLinks: {
        useTerms:
          'https://s3-eu-west-1.amazonaws.com/9sp-public/legal/chile/wsp_terms_of_use.pdf',
        privacy:
          'https://s3-eu-west-1.amazonaws.com/9sp-public/privacy_policy.pdf'
      }
    };
  },

  computed: {
    currentUser() {
      const username = store.state.user.username || 'anonymous';
      return username;
    }
  },
  mounted() {
    // Set page title
    document.title = 'Cierre temporal de wesmartPark en Chile';
    this.loadTypeformHTML();
  },
  methods: {
    isLandscape() {
      return this.$vuetify.breakpoint.height < this.$vuetify.breakpoint.width;
    },
    isLarge() {
      return this.$vuetify.breakpoint.height > 650;
    },
    logout() {
      authService.logout();
    },

    loadTypeformHTML() {
      // Crear el contenedor de Typeform
      const container = document.querySelector('.typeform-container');
      container.innerHTML = `
        <div class="mail-wrapper" style="" lang="und" dir="auto">
          <table align="left" class="wrapper" border="0" cellpadding="0" cellspacing="0" role="presentation" 
                 style="background:#FFFFFF;background-color:#FFFFFF;width:100%;margin:0px 0px 40px 0px;">
            <tbody>
              <tr>
                <td>
                  <!--[if mso | IE]>
                  <table align="left" border="0" cellpadding="0" cellspacing="0" class="wrapper-outlook" 
                         role="presentation" bgcolor="#FFFFFF">
                    <tr>
                      <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
                  <![endif]-->
                  <div style="margin:0px auto;">
                    <table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%">
                      <tbody>
                        <tr>
                          <td style="direction:ltr;font-size:0px;padding:0;text-align:left">
                            <!--[if mso | IE]>
                            <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                              <tr>
                                <td class="">
                                  <table align="left" border="0" cellpadding="0" cellspacing="0" class="" 
                                         role="presentation">
                                    <tr>
                                      <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
                            <![endif]-->
                            <div class="" style="margin:0px auto;">
                              <table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" 
                                     style="width:100%">
                                <tbody>
                                  <tr>
                                    <td style="direction:ltr;font-size:0px;padding:0px 0;text-align:left">
                                      <!--[if mso | IE]>
                                      <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                                        <tr>
                                          <td class="" style="vertical-align:top;">
                                      <![endif]-->
                                      <div class="" 
                                           style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%">
                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" 
                                               style="vertical-align:top" width="100%">
                                          <tbody>
                                            <tr>
                                              <td align="left" class="" 
                                                  style="font-size:0px;padding:10px 0px 0px 0px;word-break:break-word">
                                                <div style="font-family:'Montserrat',sans-serif;font-size:14px;font-weight:normal;line-height:32px;text-align:left;color:rgba(0, 0, 0, 0.87)">
                                                  ¿Quieres que te avisemos cuando volvamos?
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td align="left" class="" 
                                                  style="font-size:0px;padding:20px 0px;word-break:break-word">
                                                  
                                                <div style="font-family:Ubuntu,Helvetica,Arial,sans-serif;font-size:13px;line-height:1;text-align:left;color:#000000">
                                                  <a target="_blank" href="https://wsp1.typeform.com/to/CTA15wIK?typeform-medium=embed-email#username=${encodeURIComponent(
                                                    this.currentUser
                                                  )}&amp;answers-0e17be11-ee53-433f-acae-493b671855f8=0e17be11-ee53-433f-acae-493b671855f8-yes" 
                                                     style="font-family:'Source Sans Pro',sans-serif;color:rgb(0, 188, 212);font-size:14px;line-height:18px;text-decoration:none;text-align:center;padding:10px 20px;border: 1px solid rgb(0, 188, 212);border-radius:2px;background-color:rgb(255, 255, 255)">
                                                    Sí, avísenme cuando regresen.
                                                  </a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td align="left" class="" 
                                                  style="font-size:0px;padding:10px 0px;word-break:break-word">
                                                  
                                                <div style="font-family:Ubuntu,Helvetica,Arial,sans-serif;font-size:13px;line-height:1;text-align:left;color:#000000">
                                                  <a target="_blank" href="https://wsp1.typeform.com/to/CTA15wIK?typeform-medium=embed-email#username=${encodeURIComponent(
                                                    this.currentUser
                                                  )}&amp;answers-0e17be11-ee53-433f-acae-493b671855f8=0e17be11-ee53-433f-acae-493b671855f8-no" 
                                                     style="font-family:'Source Sans Pro',sans-serif;color:rgb(0, 188, 212);font-size:14px;line-height:18px;text-decoration:none;text-align:center;padding:10px 20px;border: 1px solid rgb(0, 188, 212);border-radius:2px;background-color:rgb(255, 255, 255)">
                                                    No, prefiero que borren mis datos.
                                                  </a>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <!--[if mso | IE]>
                                          </td>
                                        </tr>
                                      </table>
                                      <![endif]-->
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <!--[if mso | IE]>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                            <![endif]-->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!--[if mso | IE]>
                      </td>
                    </tr>
                  </table>
                  <![endif]-->
                </td>
              </tr>
            </tbody>
          </table>
          <style>
            #outlook a{padding:0}
            body{margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}
            table,td{border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt}
            img{border:0;height:auto;line-height:100%;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic}
            p{display:block;margin:13px 0}
            @media only screen and (min-width:480px){.mj-column-px-640{width:640px !important;max-width:640px}}
            .moz-text-html .mj-column-px-640{width:640px !important;max-width:640px}
            .mj-column-px-640{width:100% !important;max-width:640px}
            /*!sc*/
            data-styled.g1[id="sc-global-juhJZJ1"]{content:"sc-global-juhJZJ1,"}
            /*!sc*/
          </style>
          <link href="https://font.typeform.com/dist/google/ubuntu/index.css" rel="stylesheet" type="text/css">
        </div>
      `;
    }
  }
};
</script>

<style scoped>
.legal-hero {
  background: linear-gradient(to left, #36c6d3 0%, #42a5f5 100%);
  padding: 80px 0 60px 0;
}
.v-card {
  max-width: 100%;
}

.headline {
  font-weight: 500;
}

.title {
  color: #5ea4c8;
  font-weight: 500;
}

.body-1 {
  line-height: 1.6;
}

ul {
  padding-left: 20px;
}

ul li {
  margin-bottom: 8px;
}

.v-list-tile__sub-title {
  white-space: pre-line;
}
</style>
